module.exports = __webpack_public_path__ + "static/media/logo-ar.4bc6d10c.svg";